import styled from 'styled-components';
import { CssFuncs } from '../../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'modal-effect_container',
  displayName: 'ModalEffect.Container',
})`
  ${CssFuncs.css.absolute({ xy: '0px' })}
`;

const Mask = styled.div.withConfig({
  componentId: 'modal-effect_mask',
  displayName: 'ModalEffect.Mask',
})`
  ${CssFuncs.css.absolute({ xy: '0px' })}
`;

const Content = styled.div.withConfig({
  componentId: 'modal-effect_content',
  displayName: 'ModalEffect.Content',
})`
  ${CssFuncs.css.absolute({ xy: '0px', top: '200px' })}
  ${CssFuncs.css.xCenterAlignInside()}

  pointer-events: none;

  animation: fadeInAndScale 0.2s ease-out forwards;

  @keyframes fadeInAndScale {
    from {
      opacity: 0;
      transform: scale(0.98);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const ModalEffectStyle = {
  Container,
  Mask,
  Content,
};
